/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "glyph": {
                "nested": {
                  "GlyphIcon": {
                    "values": {
                      "DO_NOT_USE_GLYPH_ICON": 0,
                      "CANCEL": 1,
                      "DENY": 2,
                      "HELP": 3,
                      "INFO": 4,
                      "LOADING": 5,
                      "SUCCESS": 6,
                      "WARNING": 7,
                      "CYCLE": 8,
                      "CYCLE_BACKWARD": 9,
                      "CYCLE_FORWARD": 10,
                      "DOWN": 11,
                      "DOWN_LEFT": 12,
                      "DOWN_RIGHT": 13,
                      "LEFT": 14,
                      "RIGHT": 15,
                      "RIGHT_LEFT": 16,
                      "UP": 17,
                      "UP_BOTTOM": 18,
                      "UP_LEFT": 19,
                      "UP_RIGHT": 20,
                      "ATTACH": 21,
                      "BACKSPACE": 22,
                      "CALENDAR": 23,
                      "CALENDAR_DATE": 24,
                      "CHECK": 25,
                      "COPY": 26,
                      "DELETE": 27,
                      "DRAG": 28,
                      "EDIT": 29,
                      "FILE_DOWNLOAD": 30,
                      "FILE_UPLOAD": 31,
                      "FILTER": 32,
                      "LINK": 33,
                      "LOCK_OFF": 34,
                      "LOCK_ON": 35,
                      "MENU": 36,
                      "MESSAGE": 37,
                      "MINUS": 38,
                      "MORE": 39,
                      "NOTIFICATION": 40,
                      "PERCENTAGE": 41,
                      "PLUS": 42,
                      "SEARCH": 43,
                      "SEND": 44,
                      "SETTINGS": 45,
                      "SORT": 46,
                      "VIEW_OFF": 47,
                      "VIEW_ON": 48,
                      "X": 49,
                      "BANK": 50,
                      "CARD": 51,
                      "CARD_CHIP": 52,
                      "CARD_CHIP_MULTIPLE": 53,
                      "CARD_CONTACTLESS": 54,
                      "CARD_SWIPE": 55,
                      "CARD_SWIPE_MULTIPLE": 56,
                      "CASH": 57,
                      "CASH_MULTIPLE": 58,
                      "COIN": 59,
                      "DEPOSIT": 60,
                      "DIAMOND": 61,
                      "GIFT_CARD": 62,
                      "GOLD": 63,
                      "MONEY_BAG": 64,
                      "SIGN_USD": 65,
                      "SQUARE_CARD": 66,
                      "WALLET": 67,
                      "WITHDRAW": 68,
                      "BINOCULARS": 69,
                      "BOLT": 70,
                      "CELEBRATE": 71,
                      "CHART_BAR": 72,
                      "CHART_LINE": 73,
                      "CHART_PIE": 74,
                      "CIRCLE_1": 75,
                      "CIRCLE_2": 76,
                      "CIRCLE_3": 77,
                      "CLOCK": 78,
                      "CLOUD": 79,
                      "EMOTION_HAPPY": 80,
                      "EMOTION_SAD": 81,
                      "ENVELOPE": 82,
                      "FILE": 83,
                      "FINGER_1": 84,
                      "FINGER_2": 85,
                      "FINGER_3": 86,
                      "FLOAT": 87,
                      "FOLDER": 88,
                      "FOOD_MENU": 89,
                      "GEAR": 90,
                      "GLOBE": 91,
                      "HOME": 92,
                      "HUMAN": 93,
                      "HUMAN_MULTIPLE": 94,
                      "LOCATION_PIN": 95,
                      "LOUD_SPEAKER": 96,
                      "ROCKET": 97,
                      "SERVICE_CHARGE": 98,
                      "SHOPPING_BASKET": 99,
                      "SHOPPING_CART": 100,
                      "STAR": 101,
                      "STORE": 102,
                      "TIMER": 103,
                      "X_CIRCLE": 104,
                      "NO_ENTRY_CIRCLE": 105,
                      "QUESTION_MARK_CIRCLE": 106,
                      "I_CIRCLE": 107,
                      "CHECKMARK_CIRCLE": 108,
                      "EXCLAMATION_CIRCLE": 109,
                      "EXCLAMATION_TRIANGLE": 110,
                      "PHONE": 111,
                      "PENCIL_WRITING": 112,
                      "DOGEARED_PAPER": 113,
                      "PRINT": 114,
                      "PAPER_CHECK": 115,
                      "HUMAN_COUPLE": 116,
                      "BUILDINGS": 117,
                      "CAR": 118,
                      "BOX": 119,
                      "DOGEARED_PAPER_SIGN_DOLLAR": 120,
                      "DOGEARED_PAPER_SIGN_EUR": 121,
                      "DOGEARED_PAPER_SIGN_GBP": 122,
                      "DOGEARED_PAPER_SIGN_JPY": 123,
                      "BELL": 124,
                      "BELL_Z": 125,
                      "BOX_ARROW": 126,
                      "CALENDAR_PLUS": 127,
                      "CALL": 128,
                      "CHAIN_LINKS": 129,
                      "CHAIN_LINKS_SLASH": 130,
                      "DASHED_CLOCK": 131,
                      "ELLIPSIS_HORIZONTAL": 132,
                      "ELLIPSIS_VERTICAL": 133,
                      "EMOTION_PLUS": 134,
                      "EYE": 135,
                      "EYE_SLASH": 136,
                      "HUMAN_CHECK": 137,
                      "HUMAN_PLUS": 138,
                      "IMAGE_PLUS": 139,
                      "LOCATION_ARROW": 140,
                      "MESSAGE_CLOCK": 141,
                      "MESSAGE_ELLIPSES": 142,
                      "MESSAGE_HUMAN": 143,
                      "MESSAGE_MULTIPLE": 144,
                      "PENCIL_IN_BOX": 145,
                      "RECEIPT_PERCENTAGE": 146,
                      "RECEIPT_CHECKMARK": 147,
                      "RECEIPT_X": 148,
                      "SCAN": 149,
                      "SCAN_BARCODE": 150,
                      "SHAPES": 151,
                      "SQUARE_CHECKMARK": 152,
                      "TILES_PLUS": 153,
                      "RADIAL_SPINNER": 154,
                      "ARROW_CLOCK": 155,
                      "ARROW_DOWN_LETTERS": 156,
                      "ARROW_DOWN_LINES": 157,
                      "ARROW_UP_LETTERS": 158,
                      "ARROW_UP_LINES": 159,
                      "BRACKET_ARROW_LEFT": 160,
                      "BRACKET_ARROW_RIGHT": 161,
                      "DUAL_ROTATING_SQUARE_ARROWS": 162,
                      "ENVELOPE_ARROW_RIGHT": 163,
                      "FOLDER_ARROW_RIGHT": 164,
                      "HUMAN_ARROW_RIGHT": 165,
                      "RECEIPT_ARROW_RIGHT": 166,
                      "SHOPPING_CART_ARROW": 167,
                      "UP_DOWN": 168,
                      "COIN_SIGN_DOLLAR": 169,
                      "COIN_SIGN_EUR": 170,
                      "COIN_SIGN_GBP": 171,
                      "COIN_SIGN_JPY": 172,
                      "DEPOSIT_SIGN_DOLLAR": 173,
                      "DEPOSIT_SIGN_EUR": 174,
                      "DEPOSIT_SIGN_GBP": 175,
                      "DEPOSIT_SIGN_JPY": 176,
                      "HOUSE_ACCOUNT_SIGN_DOLLAR": 177,
                      "HOUSE_ACCOUNT_SIGN_EUR": 178,
                      "HOUSE_ACCOUNT_SIGN_GBP": 179,
                      "HOUSE_ACCOUNT_SIGN_JPY": 180,
                      "MONEY_BAG_SIGN_DOLLAR": 181,
                      "MONEY_BAG_SIGN_EUR": 182,
                      "MONEY_BAG_SIGN_GBP": 183,
                      "MONEY_BAG_SIGN_JPY": 184,
                      "SIGN_DOLLAR": 185,
                      "SIGN_EUR": 186,
                      "SIGN_GBP": 187,
                      "SIGN_JPY": 188,
                      "SIGN_DOLLAR_ARROW": 189,
                      "SIGN_EUR_ARROW": 190,
                      "SIGN_GBP_ARROW": 191,
                      "SIGN_JPY_ARROW": 192,
                      "TERMINAL_SIGN_DOLLAR": 193,
                      "TERMINAL_SIGN_EUR": 194,
                      "TERMINAL_SIGN_GBP": 195,
                      "TERMINAL_SIGN_JPY": 196,
                      "FORM": 197,
                      "GIF": 198,
                      "IMAGE": 199,
                      "OFFICE_EXCEL": 200,
                      "OFFICE_POWERPOINT": 201,
                      "OFFICE_WORD": 202,
                      "PDF": 203,
                      "VIDEO": 204,
                      "CARD_SWIPE_CHECK": 205,
                      "CARD_SWIPE_EXCLAMATION": 206,
                      "CARD_SWIPE_PLUS": 207,
                      "CASH_ARROW": 208,
                      "AIRPLANE": 209,
                      "BAG": 210,
                      "BONE": 211,
                      "BRIEFCASE": 212,
                      "CAKE": 213,
                      "CARD_HUMAN_LINES": 214,
                      "CHEF_HAT": 215,
                      "CIRCLE_4": 216,
                      "CIRCLE_5": 217,
                      "CIRCLE_6": 218,
                      "CIRCLE_7": 219,
                      "CIRCLE_8": 220,
                      "CIRCLE_9": 221,
                      "CLIPBOARD": 222,
                      "CLOTHES_HANGER": 223,
                      "CLOUD_1": 224,
                      "COLOR_SELECTION": 225,
                      "CUP": 226,
                      "DASHED_CIRCLE_STAR": 227,
                      "DIAGRAM": 228,
                      "DIAGRAM_HORIZONTAL": 229,
                      "DISPOSABLE_CUP": 230,
                      "DRAWER": 231,
                      "DONATION": 232,
                      "DUMBBELL": 233,
                      "EMOTION_NEUTRAL": 234,
                      "EQUAL": 235,
                      "FIRE": 236,
                      "FOLDER_LOCK": 237,
                      "FOLDER_HUMAN": 238,
                      "FOOD_CART": 239,
                      "FORK_KNIFE": 240,
                      "FOUR_POINTED_STAR": 241,
                      "GAS_PUMP": 242,
                      "HAIR_DRYER": 243,
                      "HOLD": 244,
                      "HUMAN_BOOK": 245,
                      "LIGHTNING_BOLT": 246,
                      "MARTINI_GLASS": 247,
                      "MOVING_BOX": 248,
                      "PAGE_HEADER": 249,
                      "PALETTE": 250,
                      "PILL_BOTTLE": 251,
                      "PIN": 252,
                      "PIN_SLASH": 253,
                      "PUZZLE": 254,
                      "QUESTION_MARK": 255,
                      "RECEIPT": 256,
                      "RECEIPT_HUMAN": 257,
                      "RECEIPT_MULTIPLE": 258,
                      "SCALE": 259,
                      "SCREWDRIVER_RULER": 260,
                      "SEAT_MAP": 261,
                      "SERVICE_BELL": 262,
                      "SHOPPING_CART_CHECKMARK": 263,
                      "TAG": 264,
                      "THUMBS_UP": 265,
                      "THUMBS_DOWN": 266,
                      "TICKET": 267,
                      "TILES": 268,
                      "TROPHY": 269,
                      "UMBRELLA": 270,
                      "PHONE_WIRELESS": 271,
                      "PHONE_MESSAGE": 272,
                      "AUDIO": 273,
                      "AUDIO_SLASH": 274,
                      "BLUETOOTH": 275,
                      "BRIGHTNESS": 276,
                      "CALCULATOR": 277,
                      "CAMERA": 278,
                      "DESKTOP": 279,
                      "DIGITAL_SCALE": 280,
                      "HANDHELD_SCANNER": 281,
                      "KEYBOARD": 282,
                      "KIOSK": 283,
                      "LAPTOP": 284,
                      "MICROPHONE": 285,
                      "MICROPHONE_SLASH": 286,
                      "PAUSE_CIRCLE": 287,
                      "PLAY_CIRCLE": 288,
                      "RECEIPT_PRINTER": 289,
                      "SQUARE_READER_MAGSTRIPE": 290,
                      "SQUARE_STAND": 291,
                      "SQUARE_STAND_MOUNT": 292,
                      "SPEAKER": 293,
                      "TABLET": 294,
                      "WIFI": 295,
                      "WIFI_SLASH": 296,
                      "WIRELESS": 297,
                      "DOORDASH": 298,
                      "UBER_EATS": 299,
                      "GRUBHUB": 300,
                      "INDICATOR": 301,
                      "INDICATOR_SMALL": 302,
                      "INDICATOR_CIRCLE_ACTIVE": 303,
                      "INDICATOR_CIRCLE_INACTIVE": 304,
                      "BITCOIN": 305,
                      "FDIC": 306,
                      "FDIC_MULTICOLOR": 307,
                      "VISA_MULTICOLOR": 308,
                      "MASTERCARD_MULTICOLOR": 309,
                      "AMEX_MULTICOLOR": 310,
                      "SQUARE": 311,
                      "CASHAPP": 312,
                      "SQUARE_MULTICOLOR": 313,
                      "CASHAPP_MULTICOLOR": 314,
                      "CHEVRON_RIGHT": 315,
                      "CHEVRON_LEFT": 316,
                      "CHEVRON_UP": 317,
                      "CHEVRON_DOWN": 318
                    }
                  },
                  "GlyphIconBackwardCompatibilityConfig": {
                    "fields": {
                      "config": {
                        "type": ".squareup.bbfrontend.common.glyph.GlyphIconBackwardCompatibilityConfig.Config",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Config": {
                        "fields": {
                          "version": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": "0.0.0"
                            }
                          },
                          "icon": {
                            "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.glyph?.nested?.GlyphIcon && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.glyph?.nested?.GlyphIconBackwardCompatibilityConfig && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.glyph?.nested?.GlyphIconBackwardCompatibilityConfig?.nested?.Config) {
  $root.addJSON(jsonData);
}

/**
 * A curated list of Market Icons that are used by bb-frontend clients. Any icons that are added
 * will require a client update to map handle the mapping.
 *
 * You can find the full set of Market Icons at https://go/MarketIcons.
 *
 * SOURCE GlyphIcon @ squareup/bbfrontend/common/glyph/glyph_icon.proto at 17:1
 */
export const GlyphIcon = $root.lookupEnum('squareup.bbfrontend.common.glyph.GlyphIcon').values;
/**
 * Configuration for app backward compatibility for GlyphIcon.
 *
 * SOURCE GlyphIconBackwardCompatibilityConfig @ squareup/bbfrontend/common/glyph/glyph_icon.proto at 774:1
 */
export const GlyphIconBackwardCompatibilityConfig = $root.lookupType('squareup.bbfrontend.common.glyph.GlyphIconBackwardCompatibilityConfig');
fixType(GlyphIconBackwardCompatibilityConfig);
Builder.createAndAttachToType(GlyphIconBackwardCompatibilityConfig);
/**
 * SOURCE Config @ squareup/bbfrontend/common/glyph/glyph_icon.proto at 781:3
 */
GlyphIconBackwardCompatibilityConfig.Config = $root.lookupType('squareup.bbfrontend.common.glyph.GlyphIconBackwardCompatibilityConfig.Config');
fixType(GlyphIconBackwardCompatibilityConfig.Config);
Builder.createAndAttachToType(GlyphIconBackwardCompatibilityConfig.Config);